import api from "./module/index.js";
export default api;
